import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { motion, useInView } from "framer-motion";

const steps = [
  {
    id: "step1",
    number: "1",
    title: "Secure Bank Link",
    subtitle: "Link your bank accounts through Plaid — trusted by thousands of financial apps.",
    description: "Read-only access ensures your data stays private and protected.",
  },
  {
    id: "step2",
    number: "2",
    title: "Review Transactions",
    subtitle: "Our AI helps auto categorizing the transactions and generates IRS ready reason.",
    description: "No guessing, no confusion, no missed opportunities.",
  },
  {
    id: "step3",
    number: "3",
    title: "Generate IRS-Ready Docs",
    subtitle: "Create clear, compliant deduction reports with one tap.",
    description: "Perfect for your CPA or quick IRS submission.",
  },
];

const ThirdSection = () => {
  const [visibleSteps, setVisibleSteps] = useState([]);
  const sectionRef = useRef(null);
  const inView = useInView(sectionRef, { once: true, margin: "-100px" }); // triggers when 100px before section

  useEffect(() => {
    if (inView && visibleSteps.length === 0) {
      steps.forEach((_, idx) => {
        setTimeout(() => {
          setVisibleSteps((prev) => [...prev, idx]);
        }, idx * 600); // 0.6s delay between steps
      });
    }
  }, [inView, visibleSteps.length]);

  return (
    <section className="third-section py-5" ref={sectionRef}>
      <Container>
        {/* Title & Description */}
        <motion.div
          className="text-center mb-5"
          initial={{ opacity: 0, y: -20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="fw-bold">How WriteOffGenie Does Its Magic</h2>
          <p className="text-secondary fs-5">
            Three simple steps to smarter tax savings.
          </p>
        </motion.div>

          <Row className="justify-content-center align-items-start gx-5 m-0 p-0">
            {steps.map((step, idx) => (
                <Col md={3} className={`mb-0 step-col ${idx === 1 ? "middle-step" : ""}`}>
                  {visibleSteps.includes(idx) && (
                    <motion.div
                      className="step-div p-4 shadow-bottom"
                      initial={{ opacity: 0, y: 30 }}
                      animate={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.6 }}
                    >
                      <div className="d-flex align-items-end">
                        <div className="step-number">{step.number}</div>
                        <h5 className="step-number-title fw-bold fs-3">{step.title}</h5>
                      </div>
                      <h6 className="mb-2">{step.subtitle}</h6>
                      <p>{step.description}</p>
                    </motion.div>
                  )}
                </Col>
            ))}
          </Row>
      </Container>
    </section>
  );
};

export default ThirdSection;
